import { getFeaturesForWorkspace } from "../nav/workspaceRegistry";

export const WORKSPACE_HUB_SCREENS = {
  reports: "reports_workspace",
  import_export: "import_export_workspace",
  checklist: "checklist_workspace",
  settings: "settings_workspace",
  help: "help_workspace",
};

/** Pure allow check for /admin/workspace/:key (hub grant OR any feature tile). */
export function isWorkspaceRouteAllowed(
  workspaceKey,
  hasScreenAccess,
  { features = getFeaturesForWorkspace(workspaceKey) } = {}
) {
  const hubScreen = WORKSPACE_HUB_SCREENS[workspaceKey];
  if (hubScreen && hasScreenAccess("workspaces", hubScreen, "view")) return true;
  return features.some((f) =>
    hasScreenAccess(f.rbacModule, f.rbacScreen, f.rbacAction || "view")
  );
}
